import { render, staticRenderFns } from "./Nachspeise.vue?vue&type=template&id=40ff70c6&scoped=true"
import script from "./Nachspeise.vue?vue&type=script&lang=js"
export * from "./Nachspeise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff70c6",
  null
  
)

export default component.exports